import script from "./registered.vue?vue&type=script&setup=true&lang=js"
export * from "./registered.vue?vue&type=script&setup=true&lang=js"

import "./registered.vue?vue&type=style&index=0&id=a78f49b2&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a78f49b2"]])

export default __exports__